<template>
  <div class='pageContent' style='overflow:hidden'>
    <mu-appbar style='position:fixed;top:0;'>
      <mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback" /> 
      <span style="margin-left:-0.6rem" class="topT" >列表选房</span>
    </mu-appbar>
    <div style='margin:57px 0;'>
      <mu-list>
        <mu-list-item :title="build.HallName" v-for='build in useableBuilds'  toggleNested>
          <mu-list-item :open='floor.isSelected?true:false' v-for='floor in build.Floors' :title="floor.FloorName" toggleNested slot="nested" >
            <mu-list-item v-for='room in floor.Rooms' :title="room.ChamberNumber" slot="nested">
              <input class='checkBox' type='checkbox' :data-state='room.IsAssign' v-model="room.IsAssign" slot="right" @click='roomClick($event,room.ChamberNumber)'/>
            </mu-list-item>
          </mu-list-item>
        </mu-list-item>
      </mu-list>
      <div class='bMenu'>
        <div @click='goMap' class='left'>地图选房</div>
        <div @click='postRoom' class='right'>确认选房</div>
      </div>
    </div>
    <mu-toast v-if="toast" v-bind:message="hintMsg" @close="hideToast" id="alertline" />
  </div>
</template>

<style lang="less" scoped>
  .bMenu{
    display:flex;
    width:7.5rem;
    position:fixed;
    bottom:0;
    height:1.2rem;
    line-height:1.2rem;
    text-align:center;
    border-top:1px solid #eeeeee;
    .left{
      width:50%;
      color:#999999;
      background-color:#ffffff;
    }
    .right{
      width:50%;
      color:white;
      background-color:#27ba69;
    }
  }
  .checkBox{
    display:block;
    width: 19px;
    height: 25px;
    padding: 0 5px 0 0;
  }
  .checkBox:checked{background-color: #f4a100;}
</style>

<script>
  import api from '../../api'
  import { mapMutations, mapGetters } from 'vuex'
  export default {
    data(){
      return{
        // 接口数据
        apiData:'',
        // 建筑->楼层->可用房间
        useableBuilds:[],
        //提示信息
        hintMsg:'',
        //提示框显示状态
        toast: false,
        bookingCount:'',
        selectedRooms:[],
        params:'',
        //订单号
        resv:'',
        //用户账号
        cardNo:'',
        sign:''
      }
    },
    created(){
      console.log('program initiating....')
    },
    activated(){
      this.params = new this.URLSearchParam()
      //解析url参数
      var query = this.$route.query
      if(typeof query.resv != "undefined"){
        this.params.append('resv',query.resv)
        this.params.append('hotelcode',query.hotelcode)
        this.params.append('cardNo',query.cardNo)
        this.params.append('sign',query.sign)
        this.resv = query.resv
        this.cardNo = query.cardNo
        this.sign = query.sign
      }
      else{
        this.params.append('resv',this.g_PayOrder.OrderId);
        this.params.append('hotelcode', this.g_PayOrder.hotelcode);
        this.params.append('cardNo',this.g_UserInfo.Card_no);
        this.resv = this.g_PayOrder.OrderId
        this.cardNo = this.g_UserInfo.Card_no
      }
      console.log(this.params)
      this.loadData()
    },
    methods: {
      //用编号获取房间
      getRoomByNumber:function(number) {
        var find = ''
        this.useableBuilds.forEach((build, index, array) => {
          build.Floors.forEach((floor, index, array) => {
            floor.Rooms.forEach((room, index, array) => {
              if(room.ChamberNumber == number){
                find = room
                find.HallID = build.HallID
                find.FloorID = floor.FloorID
              }
            })
          })
        })
        return find
      },
      //初始化数据
      initData:function (){
        //总预订数
        this.bookingCount = this.apiData.BookingCount
        this.useableBuilds = this.apiData.Halls
        //初始化房间楼号、层号、选中状态
        this.useableBuilds.forEach((build, index, array) => {
          build.roomNum = 0
          build.Floors.forEach((floor, index, array) => {
            floor.roomNum = 0
            floor.Rooms.forEach((room, index, array) => {
              build.roomNum ++
              floor.roomNum ++
              room.HallID = build.HallID
              room.FloorID = floor.FloorID
              if(room.IsAssign){
                floor.isSelected = true
              }
            })
          })
        })
        this.ActiveRooms = []
        this.selectedRooms = []
        this.setSelectedRoom()
      },
      //设置选中房间
      setSelectedRoom:function(){
        this.apiData.AssignInfos.forEach((item, index, array) => {
          var room = this.getRoomByNumber(item.Room.ChamberNumber)
          this.selectedRooms.push(room)
        })
      },
      //加载酒店数据
      loadData:function () {
        this.$http.post(api.getUseableRooms(),this.params.toParam()).then((res) => {
          if(res.Result){
            this.apiData = res.Data
            //this.apiData = mapData.datas
            this.initData()
          }
          else{
            this.hintMsg = res.Message
            this.showToast()
          }
        })
      },
      //提交选房
      postRoom:function (){
        var that = this
        var params = new this.URLSearchParam();
        params.append('chamberNos',this.roomNo)
        params.append('resv',this.resv);
        params.append('cardNo',this.cardNo);
        this.$http.post(api.postRoom(),params.toParam()).then((res) => {
          if(res.Result){
            that.hintMsg = res.Data
            that.showToast()
            if(that.sign == ''){
              setTimeout(function(){
                that.$router.push({ path: '/order/OrderDetails' })
              },1000)
            }
            setTimeout(function(){
              that.$router.go(-1)
            },1000)
          }
          else{
            if(res.Message == '传入的房间号匹配子订单失败'){
              res.Message = '您选择的房间数量和预订的房间数量不匹配'
            }
            if(res.Message == '正在为您提交选房信息，请稍后……'){
              res.Message = '您的选择没有变化'
            }
            that.hintMsg = res.Message
            that.showToast();
            that.goback();
          }
        })
      },
      //点击复选框
      roomClick(event,chamberNumber){
        //当前点击的房间
        var room = this.getRoomByNumber(chamberNumber)
        //选中状态
        var state = event.target.checked
        if(state){
          //如果是选中
          room.IsAssign = true
          if(this.selectedRooms.length == this.bookingCount){
            //如果选够了，把最开始选的删除
            this.selectedRooms[0].IsAssign = false
            this.selectedRooms.shift()
          }
          //加入当前点击的房间
            this.selectedRooms.push(room)
          }
        else{
          room.IsAssign = false
          //重新确认选中房间
          this.selectedRooms = []
          this.useableBuilds.forEach((build, index, array) => {
            build.Floors.forEach((floor, index, array) => {
              floor.Rooms.forEach((room, index, array) => {
                if(room.IsAssign){
                  this.selectedRooms.push(room)
                }
              })
            })
          })
        }
      },
      //打开提示窗
      showToast: function() {
        this.toast = true
        if (this.toastTimer) clearTimeout(this.toastTimer)
          this.toastTimer = setTimeout(() => { this.toast = false }, 3000)
      },
      //隐藏提示窗
      hideToast: function() {
        this.toast = false
        if (this.toastTimer) clearTimeout(this.toastTimer)
      },
      //校验选中的房间
      selectedRoomCheck: function(){
        //1.未选中房间
        if(this.selectedRooms == '' || this.selectedRooms.length == 0){
          this.hintMsg = '请选择房间'
          return false
        }
        //2.选中的房间数量发生变化
        else if(this.selectedRooms.length != this.apiData.AssignInfos.length){
          return true
        }
        //3.选中的房间发生变化
        else{
          var that = this
          var result = false
          this.apiData.AssignInfos.forEach(function(assign, index, array){
            that.selectedRooms.forEach(function(room, index, array){
              //某个选中的房间在原来的选中房间中不存在
              if(assign.Room.ChamberNumber != room.ChamberNumber){
                result = true
              }
            })
          })
          if(!result){
            this.hintMsg = '不能选择和原来一样的房间'
          }
          return result
        }
        //4.选中房间总数是否等于预订的房间总数
      },
      // 后退一页
      goback: function() {
        javascript: history.go(-1);
      },
      //导航地图页
      goMap:function(){
        this.$router.push({ path: '/self-helpSelectRoom/selectRoomByMap' , query:this.$route.query})
      },
    },
    computed:{
      ...mapGetters([
        'g_UserInfo', 'g_PayOrder'
      ]),
      //选中房间号用逗号拼接
      roomNo(){
        var roomNo = ''
        this.selectedRooms.forEach((room, index, array) => {
          if(room.IsAssign){
            if(roomNo != ''){
              roomNo += ','
            }
            roomNo += room.ChamberNumber
          }
        })
        return roomNo
      }
    }
  }
</script>



// WEBPACK FOOTER //
// selectRoomByList.vue?1b3c7c44